<template>
    <div class="homes">

        <!--<div class="sl-img" style="position: relative">-->
        <!--<img src="../../assets/images/homes/Bitmap.png" width="100%;">-->
        <!--　　 <div class="img-title">-->
        <!--　　　　 <h2>SH32F7B01 LQFP80</h2>-->
        <!--　　　　 <h2 style="color:#EDEDED;">高速高效率可兼容单片机</h2>-->
        <!--　　　　 <span style="padding-right: 170px;">查看详情</span>-->
        <!--　　 </div>-->
        <!--</div>-->

        <!-- ============= 首页背景轮播图 ============= -->
        <div class="lunbo-box" :style="'background: url(\'web/bk/'+name+'.jpg\');background-size: 100%;'">
            <el-carousel indicator-position="none" style="height:505px;width: 1300px;margin: 0 auto;" :height="'505px'">
                <el-carousel-item
                        v-for="(item,index) in abc_img"
                        :key="index">
                    <img :onclick="item.type_img?'window.open(\''+item.type_img+'\')':''" :src="item.type_sign"
                         ref="bannerHeight"
                         class="lunbotu"
                         style="display: block;width: 100%;"
                         :style="item.type_img?'cursor: pointer;':''"
                         @load="imgLoad"/>
                    <div v-if="!item.type_img"
                     class="lb-content"
                    :class="{
                        upperLeft:item.type_staue == 1, upperRight:item.type_staue == 2,
                        lowerLeft:item.type_staue == 3,lowerRight:item.type_staue == 4,
                        theMiddle:item.type_staue == 5}">
                        <div class="lb-btitle">{{item.type_all_name}}</div>
                        <div class="lb-mtitle">{{item.type_name}}</div>
                        <div class="lb-url"><a :href="item.type_url">{{item.type_e_all_name}}</a></div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>

        <!-- ============= 解决方案 ============= -->
        <div class="homes-solution" style="height: 80px;width: 100%;line-height:30px;background-color: #F0F0F0">
            <ul style="list-style-type:none;cursor:pointer;line-height: 80px;text-align: center;margin: 0 auto;padding: 0;height: 80px;width: 900px">
                <li v-for="(item,index) in items"
                    :key="index"
                    :class="{'selected':flag == index}"
                    style="float: left;height: 80px;width: 300px;font-size: 24px"
                    @click="productBoxShow(index)">{{item.title}}
                </li>
            </ul>
        </div>

        <!-- ============= 芯片背景图 ============= -->
        <div v-show="productShow" class="img-electricity" style="height: 170px;">
            <ul style="list-style-type:none;cursor:pointer;height: 120px;margin: 0 auto;padding-top: 10px;width: 1300px;text-align: center">
                <li>
                    <img v-show="jdUnActive" src="../../assets/images/homes/jiadian1.png" @click="jdBackground">
                    <img v-show="jdActive" src="../../assets/images/homes/jiadian.png" @click="jdBackground">
                    <p>家电</p>
                </li>

                <li>
                    <img v-show="djUnActive" src="../../assets/images/homes/dianji.png" @click="djBackground">
                    <img v-show="djActive" src="../../assets/images/homes/dianji1.png" @click="djBackground">
                    <p>电机</p>
                </li>

                <li>
                    <img v-show="dbUnActive" src="../../assets/images/homes/dianbiao.png" @click="dbBackground">
                    <img v-show="dbActive" src="../../assets/images/homes/dianbiao1.png" @click="dbBackground">
                    <p>表计</p>
                </li>

                <li>
                    <img v-show="smUnActive" src="../../assets/images/homes/shuma.png" @click="smBackground">
                    <img v-show="smActive" src="../../assets/images/homes/shuma1.png" @click="smBackground">
                    <p>数码</p>
                </li>

                <li>
                    <img v-show="dyUnActive" src="../../assets/images/homes/dianyuan.png" @click="dyBackground">
                    <img v-show="dyActive" src="../../assets/images/homes/dianyuan1.png" @click="dyBackground">
                    <p>电源</p>
                </li>
                
                <li>
                    <img v-show="spUnActive" src="../../assets/images/homes/zhongduan.png" @click="spBackground">
                    <img v-show="spActive" src="../../assets/images/homes/zhongduan1.png" @click="spBackground">
                    <p>智能终端</p>
                </li>
                <li>
                    <img v-show="carUnActive" src="../../assets/images/homes/cat.png" @click="carBackground">
                    <img v-show="carActive" src="../../assets/images/homes/cat1.png" @click="carBackground">
                    <p>汽车电子</p>
                </li>
            </ul>
        </div>

        <div v-show="solutionShow" class="plans">
            <!--<span>解决方案</span>-->
            <!--<el-tag >查看全部解决方案>></el-tag>-->
            <div class="plans-box">
                <div class="plan">
                    <div class="plan-title">电表产品</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                </div>
                <div class="plan">
                    <div class="plan-title">电表产品</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                </div>
                <div class="plan">
                    <div class="plan-title">电表产品</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                </div>
                <div class="plan">
                    <div class="plan-title">电表产品</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                </div>
                <div class="plan">
                    <div class="plan-title">电表产品</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                </div>
                <div class="plan">
                    <div class="plan-title">电表产品</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                    <div class="plan-content">电力线载波通信PLC芯片</div>
                </div>
            </div>
        </div>

        <div class="develop-resource" v-show="resourceShow">
            <div class="resource-box">
                <ul>
                    <li>
                        <img src="../../assets/images/homes/32MCU.png">
                        <span>32BITMCU</span>
                    </li>
                    <li>
                        <img src="../../assets/images/homes/32MCU.png">
                        <span>32BITMCU</span>
                    </li>
                    <li>
                        <img src="../../assets/images/homes/32MCU.png">
                        <span>32BITMCU</span>
                    </li>
                    <li>
                        <img src="../../assets/images/homes/32MCU.png">
                        <span>32BITMCU</span>
                    </li>
                    <li>
                        <img src="../../assets/images/homes/32MCU.png">
                        <span>32BITMCU</span>
                    </li>
                    <li>
                        <img src="../../assets/images/homes/32MCU.png">
                        <span>32BITMCU</span>
                    </li>
                    <li>
                        <img src="../../assets/images/homes/32MCU.png">
                        <span>32BITMCU</span>
                    </li>
                    <li>
                        <img src="../../assets/images/homes/32MCU.png">
                        <span>32BITMCU</span>
                    </li>
                    <li>
                        <img src="../../assets/images/homes/32MCU.png">
                        <span>32BITMCU</span>
                    </li>
                </ul>
            </div>
        </div>

        <div v-show="jdShow" class="sw-column" :key="item">
            <div class="shuffling-box">
                <div class="angle jd-angle"></div>
                <div class="jd-content">
                    <div class="jd-title">中 颖&nbsp;&nbsp;(HA)&nbsp;&nbsp;芯 片</div>
                    <div class="jd-headlines"><span>方便</span> · <span>快速</span> · <span>优越</span></div>
                    <div class="jd-shuffling">
                        <el-carousel type="card" height="350px">
                            <el-carousel-item v-for="item in productShuffling['1']" :key="item">
                                <div v-for="(data,index) in item"
                                     :key="index"
                                     class="carousel"
                                     :style="'background:'+data.bgColor+';color:'+data.color+';'">
                                    <img :src="data.icon">
                                    <div class="carousel-title">{{data.title}}</div>
                                    <div class="carousel-text" style="max-height: 205px;overflow: auto;">{{data.text}}</div>
                                    <div class="carousel-btn">
                                        <a :href="'seach?search='+data.title" :style="'color:'+data.color+';'">了解详情</a>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
            <img src="../../assets/images/homes/bj2.png" style="width: 100%;height: 600px;">
        </div>

        <div v-show="djShow" class="sw-column sw-dj">
            <div class="shuffling-box">
                <div class="angle dj-angle"></div>
                <div class="jd-content">
                    <div class="jd-title">中 颖&nbsp;&nbsp;(MT)&nbsp;&nbsp;芯 片</div>
                    <div class="jd-headlines"><span>方便</span> · <span>快速</span> · <span>优越</span></div>
                    <div class="jd-shuffling">
                        <el-carousel type="card" height="350px">
                            <el-carousel-item v-for="item in productShuffling['11']" :key="item">
                                <div v-for="(data,index) in item"
                                     :key="index"
                                     class="carousel"
                                     :style="'background:'+data.bgColor+';color:'+data.color+';'">
                                    <img :src="data.icon">
                                    <div class="carousel-title">{{data.title}}</div>
                                    <div class="carousel-text" style="max-height: 205px;overflow: auto;">{{data.text}}</div>
                                    <div class="carousel-btn">
                                        <a :href="'seach?search='+data.title" :style="'color:'+data.color+';'">了解详情</a>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
            <img src="../../assets/images/homes/Bitmap.png" style="width: 100%;height: 600px;">
        </div>

        <div v-show="dbShow" class=" sw-column sw-db">
            <div class="shuffling-box">
                <div class="angle db-angle"></div>
                <div class="jd-content">
                    <div class="jd-title">中 颖&nbsp;&nbsp;(SE)&nbsp;&nbsp;芯 片</div>
                    <div class="jd-headlines"><span>方便</span> · <span>快速</span> · <span>优越</span></div>
                    <div class="jd-shuffling">
                        <el-carousel type="card" height="350px">
                            <el-carousel-item v-for="item in productShuffling['7']" :key="item">
                                <div v-for="(data,index) in item"
                                     :key="index"
                                     class="carousel"
                                     :style="'background:'+data.bgColor+';color:'+data.color+';'">
                                    <img :src="data.icon">
                                    <div class="carousel-title">{{data.title}}</div>
                                    <div class="carousel-text" style="max-height: 205px;overflow: auto;">{{data.text}}</div>
                                    <div class="carousel-btn">
                                        <a :href="'seach?search='+data.title" :style="'color:'+data.color+';'">了解详情</a>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
            <img src="../../assets/images/homes/bj2.png" style="width: 100%;height: 600px;">
        </div>

        <div v-show="smShow" class=" sw-column sw-sm">
            <div class="shuffling-box">
                <div class="angle sm-angle"></div>
                <div class="jd-content">
                    <div class="jd-title">中 颖&nbsp;&nbsp;(CA)&nbsp;&nbsp;芯 片</div>
                    <div class="jd-headlines"><span>方便</span> · <span>快速</span> · <span>优越</span></div>
                    <div class="jd-shuffling">
                        <el-carousel type="card" height="350px">
                            <el-carousel-item v-for="item in productShuffling['17']" :key="item">
                                <div v-for="(data,index) in item"
                                     :key="index"
                                     class="carousel"
                                     :style="'background:'+data.bgColor+';color:'+data.color+';'">
                                    <img :src="data.icon">
                                    <div class="carousel-title">{{data.title}}</div>
                                    <div class="carousel-text" style="max-height: 205px;overflow: auto;">{{data.text}}</div>
                                    <div class="carousel-btn">
                                        <a :href="'seach?search='+data.title" :style="'color:'+data.color+';'">了解详情</a>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
            <img src="../../assets/images/homes/Bitmap.png" style="width: 100%;height: 600px;">
        </div>

        <div v-show="dyShow" class=" sw-column sw-img">
            <div class="shuffling-box">
                <div class="angle dy-angle"></div>
                <div class="jd-content">
                    <div class="jd-title">中 颖&nbsp;&nbsp;(HP)&nbsp;&nbsp;芯 片</div>
                    <div class="jd-headlines"><span>方便</span> · <span>快速</span> · <span>优越</span></div>
                    <div class="jd-shuffling">
                        <el-carousel type="card" height="350px">
                            <el-carousel-item v-for="item in productShuffling['23']" :key="item">
                                <div v-for="(data,index) in item"
                                     :key="index"
                                     class="carousel"
                                     :style="'background:'+data.bgColor+';color:'+data.color+';'">
                                    <img :src="data.icon">
                                    <div class="carousel-title">{{data.title}}</div>
                                    <div class="carousel-text" style="max-height: 205px;overflow: auto;">{{data.text}}</div>
                                    <div class="carousel-btn">
                                        <a :href="'seach?search='+data.title" :style="'color:'+data.color+';'">了解详情</a>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
            <img src="../../assets/images/homes/bj2.png" style="width: 100%;height: 600px;">
        </div>
        
        <div v-show="spShow" class=" sw-column sw-img">
            <div class="shuffling-box">
                <div class="angle sp-angle"></div>
                <div class="jd-content">
                    <div class="jd-title">中 颖&nbsp;&nbsp;(SP)&nbsp;&nbsp;芯 片</div>
                    <div class="jd-headlines"><span>方便</span> · <span>快速</span> · <span>优越</span></div>
                    <div class="jd-shuffling">
                        <el-carousel type="card" height="350px">
                            <el-carousel-item v-for="item in productShuffling['25']" :key="item">
                                <div v-for="(data,index) in item"
                                     :key="index"
                                     class="carousel"
                                     :style="'background:'+data.bgColor+';color:'+data.color+';'">
                                    <img :src="data.icon">
                                    <div class="carousel-title">{{data.title}}</div>
                                    <div class="carousel-text" style="max-height: 205px;overflow: auto;">{{data.text}}</div>
                                    <div class="carousel-btn">
                                        <a :href="'seach?search='+data.title" :style="'color:'+data.color+';'">了解详情</a>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
            <img src="../../assets/images/homes/bj2.png" style="width: 100%;height: 600px;">
        </div>
        
        <div v-show="carShow" class=" sw-column sw-img">
            <div class="shuffling-box">
                <div class="angle car-angle"></div>
                <div class="jd-content">
                    <div class="jd-title">中 颖&nbsp;&nbsp;(AUTO)&nbsp;&nbsp;芯 片</div>
                    <div class="jd-headlines"><span>可靠</span> · <span>稳定</span> · <span>安全</span></div>
                    <div class="jd-shuffling">
                        <el-carousel type="card" height="350px">
                            <el-carousel-item v-for="item in productShuffling['116']" :key="item">
                                <div v-for="(data,index) in item"
                                     :key="index"
                                     class="carousel"
                                     :style="'background:'+data.bgColor+';color:'+data.color+';'">
                                    <img :src="data.icon">
                                    <div class="carousel-title">{{data.title}}</div>
                                    <div class="carousel-text" style="max-height: 205px;overflow: auto;">{{data.text}}</div>
                                    <div class="carousel-btn">
                                        <a :href="'seach?search='+data.title" :style="'color:'+data.color+';'">了解详情</a>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
            <img src="../../assets/images/homes/bj2.png" style="width: 100%;height: 600px;">
        </div>

        <!-- ============= 资讯 ============= -->
        <div class="now-news" style="height: 500px;">
            <div class="now-news-title">
                <span class="news-title">最新新闻</span>
                <div class="news-btn">
                    <!--el-tag class="active">企业资讯</el-tag>
                    <el-tag class="is-active">行业资讯</el-tag-->
                    <el-tag class="is-active" onclick="window.open('news');" style="cursor: pointer;">更多</el-tag>
                </div>
            </div>
            <div class="now-article">
                <div :onclick="'window.location=\'article?new_id='+item.new_id+'\''" class="now-theme" style="height: 130px;cursor: pointer;" v-for="(item ,index) in consultingData" :key="index">
                    <div class="title-time">{{item.new_have.substring(5,item.new_have.length)}}</div>
                    <div class="title-text" style="cursor: pointer;white-space: nowrap;overflow: hidden;">{{item.new_tit}} </div>
                    <div class="content-time">{{item.new_have.substring(0,4)}}</div>
                    <div class="content-text">
                        <div v-html="JSON.parse(item.new_show)" style="cursor: pointer;"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ============= 标杆背景图 ============= -->
        <div class="benchmark-img" style="position: relative">
            <img src="../../assets/images/homes/fenge.png" style="width: 100%">
            <div style="position: absolute;color: #fff;font-size: 36px;left: 35%;top: 30%">根基长青且永续稳固的卓越标杆企业</div>
        </div>

        <!-- ============= 企业成就 ============= -->
        <div class="achievement" style="height: 136px;text-align:center;">
            <ul style="height: 160px;margin: 0 auto;width: 1300px">
                <li class="achievement-li">
                    <span class="achievement-span">1994</span>
                    <span>年</span>
                    <p>注册成立于1994年</p>
                </li>
                <li class="achievement-divider"></li>
                <li class="achievement-li">
                    <span class="achievement-span">400+</span>
                    <span>人</span>
                    <p>拥有员工数量400余人</p>
                </li>
                <li class="achievement-divider"></li>
                <li class="achievement-li">
                    <span class="achievement-span">100+</span>
                    <span>家</span>
                    <p>100多家合作企业</p>
                </li>
            </ul>
        </div>

        <!-- ============= 企业历程大事件 ============= -->
        <!--div class="business-process">
            <div class="process-title">企业历程大事件</div>
            <div class="process-box">
                <div class="process-event" style="overflow: auto;">
                    <div v-for="(item,index) in businessProcess" :key="index" class="product">
                        <img class="location"
                             :class="{imgSingle:(index+1) % 2 == 1, imgDouble:(index+1)%2 ==0}"
                             :src="item.first_img">
                        <div class="location product-rhombus" :style="'background:'+item.first_color+';'"></div>
                        <div class="location product-time">{{item.first_years}}</div>
                        <div class="location product-line"
                             :class="{lineSingle:(index+1) % 2 == 1, lineDouble:(index+1)%2 ==0}"
                             :style="'background:'+item.first_color+';'"></div>
                        <div class="location product-point"
                             :class="{pointSingle:(index+1) % 2 == 1, pointDouble:(index+1)%2 ==0}"
                             :style="'background:'+item.first_color+';'"></div>
                        <div class="location product-title"
                             :class="{titleSingle:(index+1) % 2 == 1, titleDouble:(index+1)%2 ==0}"
                        >{{item.first_msg}}
                        </div>
                    </div>
                </div>
            </div>
        </div-->

        <!-- ============= 部分合作伙伴 ============= -->
        <!--div class="partners">
            <div class="partners-title">部分合作伙伴</div>
            <div class="partners-box">
                <el-carousel trigger="click">
                    <el-carousel-item v-for="(item,index) in partnersList" :key="item">
                        <div
                          class="partners-div"
                          v-for="(data,dataIndex) in item"
                          :key="data"
                          @mouseenter="onMousteIn(dataIndex)"
                          @mouseleave="onMousteOut()">
                            <img class="partners-img" :src="seen&&dataIndex==current?data.first_img_2 : data.first_img" @click="linkSkip(data.first_url)">
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div-->

        <!-- ============= 合作商家 ============= -->
        <div class="merchants">
            <div class="merchants-box">
                <div class="merchants-title">合作商家</div>
                <div class="merchants-card" v-for="item in merchantList" :key="item"><img :src=item.first_img @click="linkSkip(item.first_url)">
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'homes',
    data () {
        return {
            businessProcess: [
                // {
                //     first_img: require("../../assets/images/homes/Bitmap.png"),
                //     title: '推出电表控制芯片',
                //     time: '2015年',
                //     first_color: '#51bfff'
                // }, {
                //     first_img: require("../../assets/images/homes/Bitmap.png"),
                //     title: '推出电表控制芯片',
                //     time: '2015年',
                //     first_color: '#51bfff'
                // }, {
                //     first_img: require("../../assets/images/homes/Bitmap.png"),
                //     title: '推出电表控制芯片',
                //     time: '2015年',
                //     first_color: '#51bfff'
                // }, {
                //     first_img: require("../../assets/images/homes/Bitmap.png"),
                //     title: '推出电表控制芯片',
                //     time: '2015年',
                //     first_color: '#51bfff'
                // }, {
                //     first_img: require("../../assets/images/homes/Bitmap.png"),
                //     title: '推出电表控制芯片',
                //     time: '2015年',
                //     first_color: '#51bfff'
                // }, {
                //     first_img: require("../../assets/images/homes/Bitmap.png"),
                //     title: '推出电表控制芯片',
                //     time: '2015年',
                //     first_color: '#cccccc'
                // }
            ], // 公司历程
            partnersList: [
                // [
                //     require("../../assets/images/homes/meidi.png"),
                //     require("../../assets/images/homes/tcl.png"),
                //     require("../../assets/images/homes/hi.png"),
                //     require("../../assets/images/homes/bengteng.png"),
                //     require("../../assets/images/homes/sbr.png"),
                //     require("../../assets/images/homes/gls.png"),
                //     require("../../assets/images/homes/aks.png"),
                //     require("../../assets/images/homes/ls.png"),
                // ],
                // [
                //     require("../../assets/images/homes/bengteng.png"),
                //     require("../../assets/images/homes/sbr.png"),
                //     require("../../assets/images/homes/gls.png"),
                //     require("../../assets/images/homes/aks.png"),
                //     require("../../assets/images/homes/ls.png"),
                //     require("../../assets/images/homes/ls.png"),
                //     require("../../assets/images/homes/meidi.png"),
                //     require("../../assets/images/homes/tcl.png"),
                // ],
                // [
                //     require("../../assets/images/homes/sbr.png"),
                //     require("../../assets/images/homes/gls.png"),
                //     require("../../assets/images/homes/aks.png"),
                //     require("../../assets/images/homes/ls.png"),
                //     require("../../assets/images/homes/bengteng.png"),
                //     require("../../assets/images/homes/sbr.png"),
                //     require("../../assets/images/homes/gls.png"),
                //     require("../../assets/images/homes/aks.png"),
                // ]
            ], // 合作对象
            merchantList:[], // 合作商家
            productShuffling: {}, // 产品轮播
            current: 0,// 鼠标移入图片下标
            seen: false, //鼠标移入移出状态
            jdActive: true,
            jdUnActive: false,
            djActive: false,
            djUnActive: true,
            dbActive: false,
            dbUnActive: true,
            smActive: false,
            smUnActive: true,
            dyActive: false,
            dyUnActive: true,
            spActive: false,
            spUnActive:true,
            carUnActive:true,
            jdShow: true,
            djShow: false,
            dbShow: false,
            smShow: false,
            dyShow: false,
            spShow: false,
            carShow: false,
            productShow: true,
            solutionShow: false,
            resourceShow: false,
            flag: -1,
            bannerHeight: '',
            items: [{title: '产品'}/*, {title: '解决方案'}, {title: '开发资源'}*/],
            abc_img: [], // 轮播图数据
            consultingData:[], // 最新资讯
            name:'bk1',//背景图名
        }
    },
    mounted: function () {
        this.judgeVersions()
        
        this.name='bk'+Math.floor(Math.random()*10+1);
        
        this.listData();
        this.ProData();
        this.imgLoad();
        window.addEventListener('resize', () => {
            this.bannerHeight = this.$refs.bannerHeight[0].height;
            this.imgLoad();
        }, false);
        this.productBoxShow(0);
        this.sdent();// 轮播图
        this.getConsulting(); // 最新资讯
    },
    methods: {
        sdent(){ // 轮播图
             this.$axios({
                method:'get',
                url:'/api/pre/json_go/look_one?type=2',
            }).then((response) =>{          //这里使用了ES6的语法
                this.abc_img = response.data.men[0].child;
            }).catch((error) =>
                console.log(error)       //请求失败返回的数据
            )
        },
        getConsulting () { // 最新资讯
        let vm = this;
         this.$axios({
                method:'get',
                url:'/api/pre/json_go/look_news?type=1.1',
            }).then((response) =>{          //这里使用了ES6的语法
                this.consultingData = response.data.news;
            }).catch((error) =>
                console.log(error)       //请求失败返回的数据
            )

        },
        imgLoad () {
            this.$nextTick(() => {
                this.bannerHeight = this.$refs.bannerHeight[0].height;
            })
        },
        jdImg: function () {
            this.jdShow = true;
            this.djShow = false;
            this.dbShow = false;
            this.smShow = false;
            this.dyShow = false;
            this.spShow = false;
            this.carShow = false;
        },
        djImg: function () {
            this.jdShow = false;
            this.djShow = true;
            this.dbShow = false;
            this.smShow = false;
            this.dyShow = false;
            this.spShow = false;
            this.carShow = false;
        },
        dbImg: function () {
            this.jdShow = false;
            this.djShow = false;
            this.dbShow = true;
            this.smShow = false;
            this.dyShow = false;
            this.spShow = false;
            this.carShow = false;
        },
        smImg: function () {
            this.jdShow = false;
            this.djShow = false;
            this.dbShow = false;
            this.smShow = true;
            this.dyShow = false;
            this.spShow = false;
            this.carShow = false;
        },
        dyImg: function () {
            this.jdShow = false;
            this.djShow = false;
            this.dbShow = false;
            this.smShow = false;
            this.dyShow = true;
            this.spShow = false;
            this.carShow = false;
        },
        spImg: function () {
            this.jdShow = false;
            this.djShow = false;
            this.dbShow = false;
            this.smShow = false;
            this.dyShow = false;
            this.spShow = true;
            this.carShow = false;
        },
        carImg: function () {
            this.jdShow = false;
            this.djShow = false;
            this.dbShow = false;
            this.smShow = false;
            this.dyShow = false;
            this.spShow = false;
            this.carShow = true;
        },

        // 产品、解决方案、开发资源 对应详情box
        productBoxShow: function (index) {
            this.flag = index;
            if (index == 0) {
                this.productShow = true;
                this.solutionShow = false;
                this.resourceShow = false;
                this.jdShow = true;
                this.djShow = false;
                this.dbShow = false;
                this.smShow = false;
                this.dyShow = false;
                this.spShow = false;
                this.carShow = false;
            } else if (index == 1) {
                this.productShow = false;
                this.solutionShow = true;
                this.resourceShow = false;
                this.jdShow = false;
                this.djShow = false;
                this.dbShow = false;
                this.smShow = false;
                this.dyShow = false;
                this.spShow = false;
                this.carShow = false;
            } else if (index == 2) {
                this.productShow = false;
                this.solutionShow = false;
                this.resourceShow = true;
                this.jdShow = false;
                this.djShow = false;
                this.dbShow = false;
                this.smShow = false;
                this.dyShow = false;
                this.spShow = false;
                this.carShow = false;
            }
        },
        // 家电、电机、电表 点击激活背景色变为蓝色
        jdBackground: function () {
            this.jdActive = true;
            this.jdUnActive = false;
            this.djActive = false;
            this.djUnActive = true;
            this.dbActive = false;
            this.dbUnActive = true;
            this.dbActive = false;
            this.smUnActive = true;
            this.smActive = false;
            this.dyUnActive = true;
            this.dyActive = false;
            this.spUnActive = true;
            this.spActive = false;
            this.carUnActive = true;
            this.carActive = false;
            this.jdImg();
        },
        djBackground: function () {
            this.jdActive = false;
            this.jdUnActive = true;
            this.djActive = true;
            this.djUnActive = false;
            this.dbActive = false;
            this.dbUnActive = true;
            this.smUnActive = true;
            this.smActive = false;
            this.dyUnActive = true;
            this.dyActive = false;
            this.spUnActive = true;
            this.spActive = false;
            this.carUnActive = true;
            this.carActive = false;
            this.djImg();
        },
        dbBackground: function () {
            this.jdActive = false;
            this.jdUnActive = true;
            this.djActive = false;
            this.djUnActive = true;
            this.dbActive = true;
            this.dbUnActive = false;
            this.smUnActive = true;
            this.smActive = false;
            this.dyUnActive = true;
            this.dyActive = false;
            this.spUnActive = true;
            this.spActive = false;
            this.carUnActive = true;
            this.carActive = false;
            this.dbImg();
        },
        smBackground: function () {
            this.jdActive = false;
            this.jdUnActive = true;
            this.djActive = false;
            this.djUnActive = true;
            this.dbActive = false;
            this.dbUnActive = true;
            this.smUnActive = false;
            this.smActive = true;
            this.dyUnActive = true;
            this.dyActive = false;
            this.spUnActive = true;
            this.spActive = false;
            this.carUnActive = true;
            this.carActive = false;
            this.smImg();
        },
        dyBackground: function () {
            this.jdActive = false;
            this.jdUnActive = true;
            this.djActive = false;
            this.djUnActive = true;
            this.dbActive = false;
            this.dbUnActive = true;
            this.smUnActive = true;
            this.smActive = false;
            this.dyUnActive = false;
            this.dyActive = true;
            this.spUnActive = true;
            this.spActive = false;
            this.carUnActive = true;
            this.carActive = false;
            this.dyImg();
        },
        spBackground: function () {
            this.jdActive = false;
            this.jdUnActive = true;
            this.djActive = false;
            this.djUnActive = true;
            this.dbActive = false;
            this.dbUnActive = true;
            this.smUnActive = true;
            this.smActive = false;
            this.dyUnActive = true;
            this.dyActive = false;
            this.spUnActive = false;
            this.spActive = true;
            this.carUnActive = true;
            this.carActive = false;
            this.spImg();
        },
        carBackground: function () {
            this.jdActive = false;
            this.jdUnActive = true;
            this.djActive = false;
            this.djUnActive = true;
            this.dbActive = false;
            this.dbUnActive = true;
            this.smUnActive = true;
            this.smActive = false;
            this.dyUnActive = true;
            this.dyActive = false;
            this.spUnActive = true;
            this.spActive = false;
            this.carUnActive = false;
            this.carActive = true;
            this.carImg();
        },
        // 点击合作商家图片跳转方法
        linkSkip: function (firstUrl) {
            //window.location.href = firstUrl
            window.open(firstUrl)
            //window.scrollTo(0, 0);
        },
        // 查询企业历程大事件、部分合作伙伴和合作商家数据
        listData: function () {
            this.$axios({
                method:'get',
                url:'/api/pre/json_go/first',
            }).then((response) =>{ // 这里使用了ES6的语法
                let _this = this
                let Carousel = []
                let list = Object.keys(response.data).map(function (e) { return response.data[e]})
                if(list.length===3){
                    _this.businessProcess = list[0]
                    Carousel = list[1]
                    _this.merchantList = list[2]
                }
                // 把部分合作伙伴数组格式改成轮播数组格式
                let index = 0;
                while(index < Carousel.length) {
                    _this.partnersList.push(Carousel.slice(index, index += 8));
                }
                // 替换<br>
                let reg = new RegExp("<br>", "g"); // g,表示全部替换
                let keys = []
                if (_this.businessProcess.length > 0){
                    keys = Object.keys(_this.businessProcess[0])
                }
                if(keys.length > 0){
                    _this.businessProcess.map((item) => {
                        for (let i = 0; i < keys.length ; i++) {
                            item[keys[i]] = (item[keys[i]]+'').replace(reg, "\r\n")
                            if(keys[i] === 'pro_name'){
                                this.chipList.push(item[keys[i]])
                            }
                        }
                    })
                }
                
                
                clearInterval(stop)
                var i=1;var look='1';
                var max_wid=200*list[0].length-document.getElementsByClassName('process-box')[0].scrollWidth;
                stop=setInterval(function (){
                  if(look==1){
                    i=i+1; 
                  }else{
                    i=i-1;
                  }
                  if(i>max_wid){
                    look=2;
                  }
                  if(i<1){
                     look=1;
                   }
                  document.getElementsByClassName("process-event")[0].scrollLeft=i;
                },10);
            }).catch((error) =>
                console.log(error)       //请求失败返回的数据
            )
        },
        ProData: function () {
            this.$axios({
                method:'get',
                url:'/api/pre/json_go/first_pro',
            }).then((response) =>{ // 这里使用了ES6的语法
                this.productShuffling=response.data;
            }).catch((error) =>
                console.log(error)       //请求失败返回的数据
            )
        },
        // 鼠标移入
        onMousteIn: function(index) {
            this.seen = true;
            this.current = index;
        },
        // 鼠标移出
        onMousteOut: function() {
            this.seen = false;
            this.current = null;
        },
        judgeVersions(){
            // 判断是否是IE浏览器
            if (!!window.ActiveXObject || 'ActiveXObject' in window) {
              // 判断IE浏览器版本
              if (navigator.appName === 'Microsoft Internet Explorer' && parseInt(navigator.appVersion.split(';')[1].replace(/[ ]/g, '').replace('MSIE', '')) < 10) {
                document.write("<div style='position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 10000; width: 100%; height: 100%; padding-top: 200px;  background-color: #fff'><P  style='font-size: 50px; text-align: center'>请使用高版本IE10及以上浏览器或者其他主流浏览器！</P></div>")
              }
            }
          },
    }
}
</script>

<style>
    .swiper-container {
        width: 100%;
        height: 300px;
    }
    .swiper-slide {
        width: 500px;
        text-align: center;
        font-size: 18px;
        background: #fff;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }
   .homes {min-width: 1300px;}
  .homes .img-electricity > ul > li { list-style:none;cursor: pointer;float: left;width: 175px;height: 160px }
  .homes .img-electricity > ul > li > p{ margin-left: 0px }

  .homes .partner { position:relative;height: 400px }
  .homes .partner > ul > li { list-style:none;float: left;margin-left: 5%;width:240px;height:65px; }
  .homes .partner > ul > li > img { vertical-align:middle; }

  .homes .partner .partner-ul > li { list-style:none;float: left;margin-left: 5%;width:240px;height:75px;margin-top: 60px }

  .homes .achievement > ul > li { list-style:none; float: left;}
  .homes .achievement > ul > li > p { color: #999999 }
  .homes .achievement .achievement-span {font-size: 48px;font-family:Helvetica;margin-top: 120px;color: #333333; }

  .homes .img-title { position:absolute;top:15%;left:15%;color: #fff }
  .homes .homes-solution { height: 80px;width: 100%;line-height:30px;background-color: #F0F0F0 }
  .homes .achievement-li { margin-top: 15px;width: 250px }
  .homes .achievement-li p { font-size:22px;font-weight: 100;color:#999999;line-height:19px;}
  .homes .achievement-divider {width: 1px;background: #EDEDED;height: 40px;margin: 47px 35px;}
  .homes .big-event { position: relative;height: 720px;background-color: #F6F6F6;text-align: center; }
  .homes .big-event-title { position:absolute;font-size: 36px;color:#000;margin-top: 60px;margin-left: 18% }

  .homes .lunbo-box { position: relative; }
  .homes .lunbo-box .lb-content {position: absolute;}
  .lb-content .lb-btitle {color: #FFFFFF;font-size: 24px;font-weight: 500;}
  .lb-content .lb-mtitle {color: #FFFFFF;font-size: 20px;font-weight: 500;}
  .upperLeft{top: 50px;left: 280px;}
  .lowerLeft{bottom: 100px; left: 280px;}
  .upperRight{top: 50px;right: 280px;}
  .lowerRight{bottom:100px; right: 200px;}
  .theMiddle {top: 300px;left: 50%;}

  .homes .partner-list { background-color: #F6F6F6;height: 480px;text-align: center;display: inline-block;width: 100%  }
  .homes .partner-list-title { position:absolute;font-size: 36px;color:#000;margin-top: 120px;margin-left: 12% }

  .homes .homes-solution-li:hover { background-color: #fff; }
  .homes .homes-solution-li:active { display: inline-block;background-color: #fff; }
  .homes-solution .clear { clear: both;height: 0;overflow: hidden }

  .el-main { overflow: inherit !important;padding: 0 !important; }
  .selected { background-color: #fff }
  .homes .unactive { background: #F0F0F0 }
    /* 加电等栏目*/
  .sw-column .shuffling-box {width: 1300px;margin:0 auto;position: relative;top: 0px}
  .sw-column .angle{background-color: #000508;width:28px;height:28px;transform: rotate(45deg);z-index: -1; position: absolute;top: 7px;}
  .sw-column .jd-angle{left: 71px;}
  .sw-column .dj-angle{left: 251px;}
  .sw-column .db-angle{left: 426px;}
  .sw-column .sm-angle{left: 600px;}
  .sw-column .dy-angle{left: 772px;}
  .sw-column .sp-angle{left: 950px;}
  .sw-column .car-angle{left: 1123px;}
  .sw-column img{margin-top: 20px;}
  .sw-column .jd-content {position: absolute;color: #fff;top: 70px }
  .sw-column .jd-title {height:70px;line-height:58px;  font-size:46px;  font-family:Helvetica;  color: #FFFFFF;text-align: center;}
  .sw-column .jd-headlines {height:31px;  font-size:23px; font-weight: 100; color:#FFFFFF;  line-height:29px;text-align: center;}
  .sw-column .jd-headlines span {padding: 0 25px;}
  .sw-column .jd-shuffling {min-width: 1300px;margin-top: 30px}
  .jd-shuffling .carousel {width:500px;height: 300px;display:inline-block;position: relative;}
  .carousel img { width: 100px;height:100px;margin: 100px 30px;}
  .carousel .carousel-title {width:310px;font-size:26px;line-height:38px;display:inline-block;position: absolute;top: 14px;left: 160px;}
  .carousel .carousel-text {width:310px;font-size:16px;line-height:24px;display:inline-block;position: absolute;top: 50px;left: 160px;text-indent: 2em;}
  .carousel .carousel-btn {width:110px;font-size:18px;text-align:right;line-height:50px;display:inline-block;position: absolute;top: 250px;right: 40px;}
  .jd-shuffling .el-carousel__item {left: -180px;background-color: #00000096;}
  .jd-shuffling .el-carousel__item--card {width: 1000px;height: 300px;box-shadow: 2px 2px 18px #99a9bf}

  /* 资讯 */
  .now-news{min-width:1300px;width:1300px;margin: 0 auto;}
  .now-news .now-news-title{margin-top: 20px;}
  .now-news-title .news-title{height:64px;line-height:58px;font-size:48px;color:#333333;}
  .now-news-title .news-btn{display: inline-block;float: right;}
  .news-btn .el-tag{font-size: 16px;margin-right: 10px;width:114px;height:48px;line-height: 48px;border-radius:25px;text-align: center;}
  .news-btn .active{background:#4A90E2;border:1px solid #4A90E2;color:#ffffff;}
  .news-btn .is-active{background:#FFFFFF;border:1px solid #999999;color:#999999;}

  .now-article {width: 100%;margin:0;}
  .now-article .now-theme{width: 100%;padding-top: 10px;}
  .now-article .now-theme:hover {background: #4A90E2;color: #ffffff;}
  .now-article .now-theme:hover .title-time{font-size:40px;}
  .now-article .now-theme:hover .title-time,
  .now-article .now-theme:hover .title-text,
  .now-article .now-theme:hover .content-time,
  .now-article .now-theme:hover .content-text{color: #ffffff;}
  .now-theme .title-time{width:300px;line-height:60px;font-size:32px;text-align:center;font-family:Helvetica;color:#666666;display: inline-block;}
  .now-theme .title-text{width:950px;line-height:60px;font-size:32px;font-family:Helvetica;color:#333333;display: inline-block;}
  .now-theme .content-time{width:300px;height:60px;font-size:24px;text-align:center;font-family:Helvetica;color:#999999;display: inline-block;}
  .now-theme .content-text{width:950px;font-size:24px;font-weight:100;font-family:Helvetica;color:#999999;height:55px;line-height:30px;display: inline-flex;}
  .content-text div {word-break: break-all;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}

  .plans {background-color: rgba(246,246,246,1);text-align: center;padding: 30px;}
  .plans .plans-box{width: 1300px;margin: 0 auto}
  .plans-box .plan {width: 350px;height:180px;border-radius:5px;background-color: #fff;display: inline-block;margin: 20px 20px;text-align: left;padding: 20px 10px 10px 20px;}
  .plan .plan-title {color: #333333;font-size: 23px;line-height:40px;font-weight:600;}
  .plan .plan-content {color: #999999;font-size: 15px;line-height:28px;}

  .develop-resource {background-color: rgba(246,246,246,1);}
  .develop-resource .resource-box {width: 1000px;margin: 0 auto;}
  .resource-box ul {margin: 0 auto;padding: 25px 0;width: 100%;text-align: center}
  .resource-box ul li {display: inline-block;width: 250px;padding: 15px 0;}
  .resource-box ul li span {display: block;font-size: 16px;color: rgba(51,51,51,1);margin-top: 5px}

  .business-process {width: 100%;padding-bottom:20px;background-color: #F6F6F6;}
  .business-process .process-title {height: 74px;line-height: 100px;width: 1300px;margin:0 auto;font-size: 48px;color:#333333;}
  .business-process .process-box {width: 1300px;margin: 0 auto;height: 400px;overflow-y: hidden;overflow-x: hidden;white-space: nowrap;}
  .process-event .product {display: inline-block;width: 200px;height: 400px;position: relative;display: inline-block;}
  .product .location {position: absolute;}
  .product img {width: 80px;height:80px;left: 60px;}
  .product .imgSingle {top: 80px;}
  .product .imgDouble {top: 250px;}
  .product .product-rhombus {width: 175px;height: 50px;transform: skewX(-25deg);top: 180px;left: 13px;}
  .product .product-time {width:155px;line-height: 50px;color:#ffffff;font-size:28px;text-align:center;top: 180px;left: 23px;}
  .product .product-line {width: 3px;height: 120px;left: 90px;}
  .product .lineSingle {top: 230px;}
  .product .lineDouble {top: 60px;}
  .product .product-point {width: 10px;height: 10px;border-radius:25px;left: 86px;}
  .product .pointSingle {top: 350px;}
  .product .pointDouble {top: 52px;}
  .product .product-title {width:200px;line-height: 30px;color:#666666;font-size:23px;left: 98px;}
  .product .titleSingle {top: 340px;}
  .product .titleDouble {top: 40px;}

  .partners {width: 1300px;margin: 0 auto;}
  .partners .partners-title {font-size: 36px;line-height: 80px;}
  .partners .partners-img {width: 100%;height: 100%;}
  .partners-box .partners-div {width: 288px;height:100px;display: inline-block;border:1px solid #cccccc;margin: 5px 5px;text-align: center;cursor:pointer;}
  /*.partners-box .partners-div img{width: 200px;height: 60px;margin: 20px 0;}*/
  .partners-box .el-carousel__container {height: 220px;margin-bottom: 30px;}
  .partners-box .el-carousel__item {width: 1200px;margin-left: 50px;}

  .merchants {width: 100%;background-color: #F6F6F6;}
  .merchants .merchants-box{margin: 0 auto;width: 1300px;padding: 25px 0;}
  .merchants-box .merchants-title {display: inline-block;width: 200px;font-size: 36px;color:#000;float:left;}
  .merchants-box .merchants-card {display: inline-block;width: 500px;cursor:pointer;}
</style>



// WEBPACK FOOTER //
// src/pages/homes/homes.vue